import { render, staticRenderFns } from "./WidgetCard.vue?vue&type=template&id=12a5413e"
import script from "./WidgetCard.vue?vue&type=script&lang=js"
export * from "./WidgetCard.vue?vue&type=script&lang=js"
import style0 from "./WidgetCard.vue?vue&type=style&index=0&id=12a5413e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports